<template>
    <!-- 提示信息 -->
    <div class="bottom">
        <div class="line flex_layout flex_y_center">
            <SetScale :scale="scalev" :world="sale_tips" v-if="sale_tips">
                <div class="pf-regular first-span">{{ sale_tips }}</div>
            </SetScale>
            <span class="pf-regular last-span">{{ sale_text }}</span>
        </div>
    </div>
</template>
<script>
    import SetScale from "./SetScale.vue";
    export default {
        components: {
            SetScale,
        },
        name: 'GoodTip',
            data () {
            return {
                scalev : 0.8,
            }
        },
        props: {
            h_data_goodinfo:{
                type: Object,
                default () {
                    return {}
                }
            },
        },
        computed: {
            sale_tips(){
                return this.getWord(this.h_data_goodinfo,'sale_tips');
            },
            sale_text(){
                return this.getWord(this.h_data_goodinfo,'sale_text');
            }
        },
        methods:{
            getWord(obj, key){
                let v = obj.words_info ? obj.words_info : {};
                return v[key] ? v[key] : '';
            },
        },
    }
</script>
<style lang="scss" scoped>
@import "../../../assets/styles/mixins.scss";
.bottom.show{display: block;}
.bottom{
    padding:0 vws(16px);margin-top: vws(24px);font-size:vws(24px);
    .scalebox_container{display:inline-block;}
    .first-span{

        border-radius:vws(20px);padding:vws(3px) vws(12px);display:inline-block;color: #FF4F00;background: #fef1ea;
    }
    .last-span{
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
        color: #666;padding: vws(3px) 0 vws(3px) vws(15px);
    }
    .line{
        height:vws(40px);
        white-space: nowrap;
    }
}
</style>




// WEBPACK FOOTER //
// node_modules/@kkmh/pays/src/components/viphalfscreen/comp/GoodTip.vue